// extracted by mini-css-extract-plugin
export default {"wrapper":"RequestsSidebar_wrapper__COv4W"};